<template>
  <div>
    <breadcrumb :breadcrumb="breadcrumb" />
    <text-title :mainTitle="mainTitle" :subheading="subheading" />
    <div class="search-line">
      <div class="btn-box">
        <button-add @click="toAddPage"/>
        <button-export
          :href="exportUrl"
          :beforeDownload="beforeDownload"
          download="download.xls"
          value="导出"/>
        <button-add @click="toAuthorize" :value="'一键授权'"/>
      </div>
      <input-search placeholder="姓名/手机号" @search="searchKey" />
    </div>
    <table-main :tableHead="tableHead" :tableData="tableData" :total="total" :pageNum="pageNum" :pageSize="pageSize" @deleteLine="deleteLine" @goToModifyPage="goToModifyPage" @changePagination="changePagination" :operationArr="operationArr" @changeSelection="changeSelection"/>

     <el-dialog title="添加授权" :visible.sync="showTip" width="792px">
          <!--远程搜索-->
          <el-input placeholder="姓名/手机号/所属住户" v-model="requestBody.searchKey" class="input-with-select" @keyup.13.native="getBasicPersonPage" size="small" style="margin-bottom: 10px;">
            <el-button slot="append" icon="el-icon-search" @click="getBasicPersonPage" size="small" />
          </el-input>
          <el-table
            ref="authPersonTable"
            :data="authPersonData"
            @select="selectPerson"
            tooltip-effect="dark"
            style="width: 100%"
            @selection-change="handleSelectionChange">
            <el-table-column
              type="selection">
            </el-table-column>
            <el-table-column
              prop="name"
              label="姓名">
            </el-table-column>
            <el-table-column
              prop="phone"
              label="手机号">
            </el-table-column>
            <el-table-column
              prop="enterpriseName"
              label="所属住户">
            </el-table-column>
          </el-table>
          <div class="page">
            <el-pagination
              background
              @size-change="handleSizeChange2"
              @current-change="handleCurrentChange2"
              style="margin-top:15px"
              :page-sizes="[10, 20, 50, 100]"
              :current-page="this.requestBody.pageNum"
              :page-size="this.requestBody.pageSize"
              layout="total, sizes, prev, pager, next, jumper"
              :total="total2">
            </el-pagination>
          </div>

      <span slot="footer" class="dialog-footer">
        <el-button @click="cancelAthority" size="small">取 消</el-button>
        <el-button type="primary" @click="addAthority" size="small">确 定</el-button>
      </span>
    </el-dialog>

  </div>
</template>

<script>
import Breadcrumb from "../../../components/Breadcrumb/Breadcrumb";
import ButtonDelete from "../../../components/Button/ButtonDelete";
import ButtonExport from "../../../components/common/buttons/button-export";
import ButtonUpload from "../../../components/common/buttons/button-upload";
import InputSearch from "../../../components/Input/InputSearch";
import InputSelect from "../../../components/Input/InputSelect";
import TextTitle from "../../../components/Text/TextTitle";
import TableMain from "../../../components/Table/TableMain";
import { api } from "../../api/FaceRecognition";
import { bus } from "../../../utils/bus";
import { errorHandler } from "../../../utils/errorHandler";
import ButtonAdd from "../../../components/common/buttons/button-add";
import { nAlert, nSuccess } from "../../../utils/notice";

export default {
  components: {
    ButtonAdd,
    TableMain,
    InputSelect,
    InputSearch,
    ButtonUpload,
    ButtonExport,
    ButtonDelete,
    TextTitle,
    Breadcrumb
  },
  name: "face-database-authorization",
  data() {
    return {
      permissionCodes: "",
      breadcrumb: [
        {
          value: "人脸应用",
          name: "monitoring-point-management"
        },
        {
          value: "人脸库管理"
        }
      ],
      mainTitle: "",
      subheading: "",
      addController: "white-list-vehicles-add",
      exportUrl: "",
      uploadUrl: "",
      tableHead: [
        {
          prop: "personName",
          label: "姓名"
        },
        {
          prop: "phone",
          label: "手机号码"
        },
        {
          prop: "enterpriseName",
          label: "所属住户"
        },
        {
          prop: "picStatusText",
          label: "照片下发状态"
        }
      ],
      tableData: [],
      total: 0,
      total2: 0,
      pageSize: 10,
      pageNum: 1,
      selectionArr: [],
      requestData: {
        isWhite: "1",
        searchKey: ""
      },
      operationArr: ["delete"],
      showTip: false,
      requestBody: {
        pageNum: 1,
        pageSize: 10,
        searchKey: "",
        hasPhoto: 1
      },
      authPersonData: [],
      wantPersonList: [],
      currentCode: "",
      formData: {},
      formDataPart: {},
      adsStr: []
    };
  },
  created() {
    this.permissionCodes = bus.global.permissionCodes;
    this.uploadUrl = api.importCarWhiteBlack;
    this.exportUrl = `${api.exportFaceAuthorize}?yq-app-code=${
      bus.global.yqCode
    }&searchKey=${this.requestData.searchKey}`;
    this.currentCode = this.$route.params.id;
    this.getFaceDBByCode();
    this.getPage();
    // this.getBasicPersonPage();
  },
  activated() {
    this.getPage();
  },
  methods: {
    beforeDownload() {
      this.exportUrl = `${api.exportFaceAuthorize}?yq-app-code=${bus.global.yqCode}&kj-type=gy&token=${bus.global.token}&searchKey=${
        this.requestData.searchKey
      }&faceCode=${this.requestData.faceCode}`;
    },
    // 获取分页
    getPage() {
      let reqData = this.requestData;
      reqData.faceCode = this.currentCode;
      reqData.pageNum = this.pageNum;
      reqData.pageSize = this.pageSize;
      this.$axios
        .post(api.getFaceAuthorizePage, reqData)
        .then(res => {
          let data = res.data.data.list;
          data.map(v => {
            if (v.picStatus == "0") {
              v.picStatusText = "成功";
            } else {
              v.picStatusText = "失败";
            }
          });
          this.total = res.data.data.total;
          this.tableData = data;
        })
        .catch(errorHandler("获取数据失败"));
    },
    search(v) {
      this.pageNum = 1;
      this.requestData[v.key] = v.value;
      this.getPage();
    },
    searchKey(v) {
      this.pageNum = 1;
      this.requestData.searchKey = v;
      this.getPage();
    },
    changePagination(data) {
      this.pageNum = data[0];
      this.pageSize = data[1];
      this.getPage();
    },
    goToModifyPage(code) {
      this.$router.push({
        path: `/park_server/white_list_vehicles_modify/${code}`
      });
    },
    deleteLine(code) {
      this.$axios
        .post(api.deleteFaceAuthorizeByCodes, code)
        .then(res => {
          nSuccess("删除成功");
          this.getPage();
        })
        .catch(errorHandler("删除失败"));
    },
    toAddPage() {
      this.formData = this.formDataPart;
      this.wantPersonList = [];
      this.getBasicPersonPage();
      // this.showTip = true;
    },
    changeSelection(codeArr) {
      this.selectionArr = codeArr;
    },
    toAuthorize() {
      if (this.selectionArr.length == 0) {
        nAlert("请选择要授权的用户");
        return false;
      }
      this.$axios
        .post(api.authorizeAllFailed, this.selectionArr)
        .then(res => {
          nSuccess("授权成功");
          this.getPage();
        })
        .catch(errorHandler("授权失败"));
    },
    cancelAthority() {
      this.showTip = false;
    },
    addAthority() {
      this.$axios
        .post(api.FaceAuthorizeAdd, this.formData)
        .then(res => {
          nSuccess("添加成功");
          this.showTip = false;
          this.getPage();
        })
        .catch(errorHandler("添加人员失败"));
    },
    handleSelectionChange(val) {
      let adsArr = [];
      val.map(v => {
        adsArr.push(v.code);
      });
      console.log(val);
      this.adsStr = adsArr.join(",");
    },

    handleCurrentChange(val) {
      this.requestBody.pageNum = val;
      this.getBasicPersonPage();
    },
    // 选择人员
    selectPerson(selection, row) {
      selection.map(select => {
        select.personCode = select.code;
        select.personName = select.name;
        let hasPerson = false;
        this.wantPersonList.map(want => {
          if (want.code === select.code) {
            hasPerson = true;
          }
        });
        if (!hasPerson) {
          this.wantPersonList.push(select);
        }
        for (let i = 0; i < this.wantPersonList.length; i++) {
          this.wantPersonList[i].picUrl = this.wantPersonList[i].yqPicUrl;
        }
        this.formData.personList = this.wantPersonList;
      });
    },
    getBasicPersonPage() {
      this.$axios.post(api.getBasicPersonPage, this.requestBody).then(res => {
        console.log(res);
        this.total2 = res.data.data.total;
        this.authPersonData = res.data.data.list;
        this.showTip = true;
      });
    },
    getFaceDBByCode() {
      this.$axios
        .get(`${api.getFaceDBByCode}/${this.currentCode}`)
        .then(res => {
          this.formDataPart = res.data.data;
          this.formDataPart.faceCode = this.formDataPart.code;
          this.mainTitle = res.data.data.type;
        })
        .catch(errorHandler("获取详情失败"));
    },
    handleSizeChange2(val) {
      this.requestBody.pageSize = val;
      this.getBasicPersonPage();
    },
    handleCurrentChange2(val) {
      this.requestBody.pageNum = val;
      this.getBasicPersonPage();
    }
  }
};
</script>

<style scoped>
.search-line {
  display: flex;
  justify-content: space-between;
  margin: 20px 0;
}
.btn-box {
  display: flex;
  justify-content: flex-start;
}
</style>

<style lang="less">
.el-input--small .el-input__inner {
  line-height: 30px;
}
</style>



// WEBPACK FOOTER //
// src/view/FaceRecognition/FaceDatabaseManagement/FaceDatabaseAuthorization.vue